import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import isEmpty from '../../validation/is-empty';

const SelectListProduct = ({
  name,
  value,
  label,
  error,
  onChange,
  option,
  required,
  info,
  locale,
}) => {
  return (
    <div className="form-group">
      {label && (
        <label>
          {label}
          {required && <span className="text-danger">&nbsp;*</span>}
          {!isEmpty(
            info.infos.find(
              (item) => name === item.name && locale.lang === item.lang
            )
          ) && (
            <img
              src="img/information.png"
              className="info"
              alt=""
              data-tip={
                info.infos.find(
                  (item) => name === item.name && locale.lang === item.lang
                ).text
              }
            />
          )}
        </label>
      )}
      <select
        className={classnames('form-control classic', {
          'is-invalid': error,
        })}
        name={name}
        value={value}
        onChange={onChange}
      >
        <FormattedMessage id="productCategory.SelectCategory">
          {(category) => (
            <option key={category} value="0">
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="productCategory.Product">
          {(category) => (
            <option key={category} value="Product">
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="productCategory.Service">
          {(category) => (
            <option key={category} value="Service">
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="productCategory.Accommodation">
          {(category) => (
            <option key={category} value="Accommodation">
              {category}
            </option>
          )}
        </FormattedMessage>
      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

SelectListProduct.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.array.isRequired,
};

export default SelectListProduct;
